module.exports = __webpack_public_path__ + "integration-QuickBooks-logo.png?995b1d8fc02ba3db7dbe2a7395339b79";